export default __webpack_public_path__ + "static/media/Banner_Barca.e5341f30.png";